export const ACELERES_CONNECTION_TYPES = Object.freeze({
  INDIVIDUAL_OWN: 'individual_own',
  INDIVIDUAL_COMPANY: 'individual_company',
  SHARED: 'shared',
});

const TYPE_ALIASES = Object.freeze({
  compartilhado: ACELERES_CONNECTION_TYPES.SHARED,
});

export const SHARED_CONNECTION_TYPES = Object.freeze(new Set([ACELERES_CONNECTION_TYPES.SHARED, ...Object.keys(TYPE_ALIASES)]));
export const HIDDEN_PERSONAL_CONNECTION_TYPES = Object.freeze([ACELERES_CONNECTION_TYPES.INDIVIDUAL_OWN]);
export const TEAM_SCOPED_CONNECTION_TYPES = Object.freeze([
  ACELERES_CONNECTION_TYPES.INDIVIDUAL_OWN,
  ACELERES_CONNECTION_TYPES.INDIVIDUAL_COMPANY,
]);

export const normalizeAceleresConnectionType = value => {
  if (value === null || value === undefined) {
    return null;
  }

  const normalized = String(value).trim().toLowerCase();
  return TYPE_ALIASES[normalized] || normalized;
};

export const isAceleresIndividualOwn = value =>
  normalizeAceleresConnectionType(value) === ACELERES_CONNECTION_TYPES.INDIVIDUAL_OWN;

export const isAceleresIndividualCompany = value =>
  normalizeAceleresConnectionType(value) === ACELERES_CONNECTION_TYPES.INDIVIDUAL_COMPANY;

export const isAceleresIndividualType = value =>
  isAceleresIndividualOwn(value) || isAceleresIndividualCompany(value);
